import { render } from "./DefInsertTilda.vue?vue&type=template&id=5363d6ed&scoped=true"
import script from "./DefInsertTilda.vue?vue&type=script&lang=js"
export * from "./DefInsertTilda.vue?vue&type=script&lang=js"

import "./DefInsertTilda.vue?vue&type=style&index=0&id=5363d6ed&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5363d6ed"]])

export default __exports__